import { i18n } from "@translations/i18n";
import { portInPhoneRegex } from "@utils/regex";
import { emailRegex as email } from "itsf-ui-common";

export const phoneRegex = (value?: string) =>
    value === undefined || portInPhoneRegex.test(value) ? undefined : i18n.t("portin:phoneNumberError");

export const emailMustMatch = (value: string, emailValue: string | undefined) =>
    value !== emailValue ? i18n.t("control:emailMustMatch") : undefined;

export const emailRegex = (value: string) =>
    value !== "" && email.test(value) ? undefined : i18n.t("control:invalidEmail");

export const rangePriceValue = (minValue: number, maxValue: number) => (value: string) =>
    value && !Number.isNaN(Number(value)) && parseFloat(value) >= minValue && parseFloat(value) <= maxValue
        ? undefined
        : i18n.t("control:betweenAmount", { minValue: minValue.toFixed(2), maxValue: maxValue.toFixed(2) });

export const pukCodeRegex = (value: string) => (/^\d*$/.test(value) ? undefined : i18n.t("control:onlyNumbers"));
